export default function Empty() {
  return (
    <div className=" flex flex-column justify-content-center align-items-center w-full h-full py-5rem ">
      <i className="isax-directbox-default-7xl text-gray-700"></i>
      <div className="text-gray-700 mt-4">No data</div>
    </div>
  )
}
